<template>
  <div>
    <!-- Botón para abrir el diálogo, fuera del DialogPrime inicialmente -->
    <ButtonPrime 
      label="Ver Preguntas" 
      icon="pi pi-list" 
      class="p-button-info p-mb-3" 
      @click="showDialog = true"
    />

    <DialogPrime
      :visible="showDialog"
      @update:visible="showDialog = $event"
      header="Preguntas por Unidad y Capítulo"
      :modal="true"
      :style="{ width: '80vw' }"
    >
      <div class="p-d-flex p-flex-column p-ai-center">
        <h3 class="p-mb-3">
          Unidad (eje): {{ idEjeTematico }} · Capítulo: {{ idCapitulo }}
          <template v-if="idVideo"> · Video: {{ idVideo }}</template>
        </h3>
        <div v-if="loading" class="p-text-center">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
          <p>Cargando preguntas...</p>
        </div>
        <div v-else-if="preguntas.length" class="table-container p-w-100">
          <DataTablePrime
            :value="preguntas"
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[5, 10, 20]"
            responsiveLayout="scroll"
            class="p-datatable-sm"
            dataKey="id_pregunta"
          >
            <ColumnPrime field="id_pregunta" header="ID Pregunta" sortable></ColumnPrime>
            <ColumnPrime header="Pregunta (glosa)" :style="{ minWidth: '18rem' }">
              <template #body="slotProps">
                <div class="glosa-editor">
                  <TextareaPrime
                    v-model="slotProps.data.Pregunta"
                    rows="4"
                    autoResize
                    placeholder="Texto de la pregunta"
                  />
                  <ButtonPrime
                    label="Guardar glosa"
                    icon="pi pi-save"
                    class="p-button-sm p-button-secondary"
                    :loading="savingGlosaById[rowIdPregunta(slotProps.data)]"
                    @click="guardarGlosaPregunta(slotProps.data)"
                  />
                </div>
              </template>
            </ColumnPrime>
            <ColumnPrime field="Solucion" header="Solución"></ColumnPrime>
            <ColumnPrime field="ImagenPregunta" header="Imagen">
              <template #body="slotProps">
                <div class="image-container">
                  <img style="width:150px; heigth: 150px;" 
                    v-if="slotProps.data.ImagenPregunta"
                    :src="'https://estudyoo.cl/v1/' + slotProps.data.ImagenPregunta"
                    alt="Imagen Pregunta"
                    
                    @error="slotProps.data.imageBroken = true"
                    @load="slotProps.data.imageBroken = false"
                  />
                  <span v-else class="no-image">Sin imagen</span>
                  <a
                    v-if="slotProps.data.ImagenPregunta"
                    :href="'https://estudyoo.cl/v1/' + slotProps.data.ImagenPregunta"
                    target="_blank"
                    class="image-link"
                  >
                    {{ 'https://estudyoo.cl/v1/' + slotProps.data.ImagenPregunta }}
                  </a>
                </div>
              </template>
            </ColumnPrime>
            <ColumnPrime header="Estado Imagen">
              <template #body="slotProps">
                <span v-if="!slotProps.data.ImagenPregunta">Sin imagen</span>
                <span v-else-if="slotProps.data.imageBroken === true" class="broken-image">Imagen no disponible</span>
                <span v-else-if="slotProps.data.imageBroken === false" class="valid-image">Imagen válida</span>
                <span v-else>Cargando...</span>
              </template>
            </ColumnPrime>
            <ColumnPrime header="Habilidad" sortable field="HabilidadGlosa">
              <template #body="slotProps">
                {{ habilidadDisplay(slotProps.data) }}
              </template>
            </ColumnPrime>
            <ColumnPrime header="Dificultad" sortable field="DificultadGlosa">
              <template #body="slotProps">
                {{ dificultadDisplay(slotProps.data) }}
              </template>
            </ColumnPrime>
            <ColumnPrime field="IdVideo" header="ID Video" sortable></ColumnPrime>
            <ColumnPrime field="Alternativas" header="Alternativas"></ColumnPrime>
            <ColumnPrime header="Imagen (archivo)" headerStyle="width: 11rem">
              <template #body="slotProps">
                <ButtonPrime
                  :label="slotProps.data.ImagenPregunta ? 'Actualizar imagen' : 'Subir imagen'"
                  icon="pi pi-image"
                  class="p-button-sm p-button-secondary"
                  :disabled="!canUploadImageForRow(slotProps.data)"
                  :title="!canUploadImageForRow(slotProps.data) ? 'Falta ID de pregunta o de video para subir' : ''"
                  @click="openUploadImage(slotProps.data)"
                />
              </template>
            </ColumnPrime>
          </DataTablePrime>
        </div>
        <div v-else class="p-text-center">
          <p>No se encontraron preguntas para esta unidad y capítulo.</p>
        </div>
      </div>

      <template #footer>
        <ButtonPrime label="Cerrar" icon="pi pi-times" class="p-button-secondary" @click="showDialog = false" />
      </template>
    </DialogPrime>

    <DialogPrime
      :visible="showUploadDialog"
      @update:visible="onUploadDialogVisible"
      :header="uploadDialogHeader"
      :modal="true"
      :style="{ width: 'min(34rem, 95vw)' }"
    >
      <div v-if="uploadTargetRow" class="preg-unidad-upload-wrap">
        <p class="preg-unidad-upload-hint">
          Pregunta ID <strong>{{ rowIdPregunta(uploadTargetRow) }}</strong>
          · Video <strong>{{ rowIdVideoResolved(uploadTargetRow) }}</strong>
          · Capítulo <strong>{{ idCapitulo }}</strong>
        </p>
        <p v-if="uploadTargetRow.ImagenPregunta" class="preg-unidad-upload-hint is-muted">
          Ya hay una imagen en servidor; al subir un archivo nuevo se <strong>reemplaza</strong> la anterior.
        </p>
        <SubirImagen
          :key="'up-' + rowIdPregunta(uploadTargetRow)"
          :id-pregunta="rowIdPregunta(uploadTargetRow)"
          :id-video="rowIdVideoResolved(uploadTargetRow)"
          :id-capitulo="idCapitulo"
          :upload-button-label="uploadTargetRow.ImagenPregunta ? 'Actualizar imagen' : 'Subir imagen'"
          @image-uploaded="onPreguntaImageUploaded"
          @upload-error="onPreguntaImageUploadError"
        />
      </div>
      <template #footer>
        <ButtonPrime
          label="Cerrar"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="closeUploadDialog"
        />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import DialogPrime from 'primevue/dialog';
import DataTablePrime from 'primevue/datatable';
import ColumnPrime from 'primevue/column';
import ButtonPrime from 'primevue/button';
import TextareaPrime from 'primevue/textarea';
import SubirImagen from '@/components/SubirImagen.vue';
import PreguntaService from '@/services/PreguntaService';
import HabilidadService from '@/services/HabilidadService';
import DificultadService from '@/services/DificultadService';
import {
  buildIdGlosaMap,
  DIFICULTAD_LABELS_FALLBACK,
  HABILIDAD_LABELS_FALLBACK,
  resolveCatalogDisplay,
} from '@/utils/preguntaCatalogLabels';

export default {
  name: 'PreguntasPorUnidadYCapituloDialog',
  components: {
    DialogPrime,
    DataTablePrime,
    ColumnPrime,
    ButtonPrime,
    TextareaPrime,
    SubirImagen,
  },
  props: {
    idEjeTematico: {
      type: Number,
      required: true
    },
    idCapitulo: {
      type: Number,
      required: true
    },
    /** Opcional: filtra solo preguntas de ese video (un set por video dentro del capítulo). */
    idVideo: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      preguntas: [],
      loading: false,
      showDialog: false,
      showUploadDialog: false,
      uploadTargetRow: null,
      savingGlosaById: {},
      habilidadesById: {},
      dificultadesById: {},
    };
  },
  created() {
    this.loadCatalogos();
  },
  computed: {
    uploadDialogHeader() {
      if (!this.uploadTargetRow) return 'Imagen de la pregunta';
      return this.uploadTargetRow.ImagenPregunta
        ? 'Actualizar imagen de la pregunta'
        : 'Subir imagen de la pregunta';
    },
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.loadCatalogos().then(() => this.fetchPreguntas());
      }
    }
  },
  methods: {
    rowIdPregunta(row) {
      if (!row) return null;
      const v = row.id_pregunta ?? row.IdPregunta;
      if (v === undefined || v === null || v === '') return null;
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? n : null;
    },
    rowIdVideoResolved(row) {
      const fromProp = this.idVideo;
      if (fromProp != null && fromProp !== '' && Number(fromProp) > 0) {
        return Number(fromProp);
      }
      if (!row) return null;
      const rv = row.IdVideo ?? row.id_video;
      if (rv === undefined || rv === null || rv === '') return null;
      const n = Number(rv);
      return Number.isFinite(n) && n > 0 ? n : null;
    },
    canUploadImageForRow(row) {
      return !!this.rowIdPregunta(row) && !!this.rowIdVideoResolved(row);
    },
    openUploadImage(row) {
      if (!this.canUploadImageForRow(row)) return;
      this.uploadTargetRow = row;
      this.showUploadDialog = true;
    },
    onUploadDialogVisible(visible) {
      this.showUploadDialog = visible;
      if (!visible) {
        this.uploadTargetRow = null;
      }
    },
    closeUploadDialog() {
      this.showUploadDialog = false;
      this.uploadTargetRow = null;
    },
    onPreguntaImageUploaded() {
      this.$toast?.add?.({
        severity: 'success',
        summary: 'Imagen guardada',
        detail: 'La ruta quedó actualizada en la pregunta.',
        life: 4000,
      });
      this.closeUploadDialog();
      this.fetchPreguntas();
    },
    onPreguntaImageUploadError(msg) {
      const detail = typeof msg === 'string' ? msg : 'Error al subir la imagen.';
      this.$toast?.add?.({
        severity: 'error',
        summary: 'Error',
        detail,
        life: 5000,
      });
    },
    async guardarGlosaPregunta(row) {
      const idPregunta = this.rowIdPregunta(row);
      if (!idPregunta) {
        this.$toast?.add?.({
          severity: 'warn',
          summary: 'Sin ID',
          detail: 'No se pudo identificar la pregunta.',
          life: 4000,
        });
        return;
      }
      const texto = (row.Pregunta || '').trim();
      if (!texto) {
        this.$toast?.add?.({
          severity: 'warn',
          summary: 'Vacío',
          detail: 'La glosa no puede quedar vacía.',
          life: 4000,
        });
        return;
      }
      this.savingGlosaById = { ...this.savingGlosaById, [idPregunta]: true };
      try {
        await PreguntaService.actualizarGlosaPregunta(idPregunta, texto);
        row.Pregunta = texto;
        this.$toast?.add?.({
          severity: 'success',
          summary: 'Glosa guardada',
          detail: `Pregunta ${idPregunta} actualizada.`,
          life: 4000,
        });
      } catch (error) {
        const detail = error?.message || 'No se pudo guardar la glosa.';
        this.$toast?.add?.({
          severity: 'error',
          summary: 'Error',
          detail,
          life: 5000,
        });
      } finally {
        this.savingGlosaById = { ...this.savingGlosaById, [idPregunta]: false };
      }
    },
    async loadCatalogos() {
      await Promise.all([this.loadHabilidadesCatalog(), this.loadDificultadesCatalog()]);
    },
    async loadHabilidadesCatalog() {
      try {
        const r = await HabilidadService.listar({ todos: true });
        this.habilidadesById = buildIdGlosaMap(r.data);
      } catch (e) {
        console.warn('[PreguntasPorUnidadYCapitulo] No se pudo cargar catálogo de habilidades:', e);
        this.habilidadesById = {};
      }
    },
    async loadDificultadesCatalog() {
      try {
        const r = await DificultadService.listar({ vigente: true });
        this.dificultadesById = buildIdGlosaMap(r.data);
      } catch (e) {
        console.warn('[PreguntasPorUnidadYCapitulo] No se pudo cargar catálogo de dificultades:', e);
        this.dificultadesById = {};
      }
    },
    habilidadDisplay(row) {
      if (!row) return '—';
      return resolveCatalogDisplay({
        glosa: row.Habilidad,
        id: row.IdHabilidad ?? row.id_habilidad,
        byId: this.habilidadesById,
        fallback: HABILIDAD_LABELS_FALLBACK,
      });
    },
    dificultadDisplay(row) {
      if (!row) return '—';
      return resolveCatalogDisplay({
        glosa: row.Dificultad,
        id: row.IdDificultad ?? row.id_dificultad,
        byId: this.dificultadesById,
        fallback: DIFICULTAD_LABELS_FALLBACK,
      });
    },
    enrichPreguntaRow(row) {
      const habilidadGlosa = this.habilidadDisplay(row);
      const dificultadGlosa = this.dificultadDisplay(row);
      return {
        ...row,
        HabilidadGlosa: habilidadGlosa,
        DificultadGlosa: dificultadGlosa,
      };
    },
    async fetchPreguntas() {
      this.loading = true;
      this.preguntas = [];

      try {
        await this.loadCatalogos();
        const params = {
          idEjeTematico: this.idEjeTematico,
          idCapitulo: this.idCapitulo,
        };
        if (this.idVideo != null && this.idVideo > 0) {
          params.idVideo = this.idVideo;
        }
        const response = await PreguntaService.getQuestionsByUnitAndChapter(params);
        this.preguntas = (response.data || []).map((row) => this.enrichPreguntaRow(row));
        console.log('Preguntas cargadas:', this.preguntas);
      } catch (error) {
        console.error('Error al cargar preguntas:', error);
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar las preguntas', life: 3000 });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.table-container {
  width: 100%;
}
.p-mb-3 {
  margin-bottom: 1rem;
}
.preg-unidad-upload-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.preg-unidad-upload-hint {
  margin: 0;
  font-size: 0.9rem;
}
.preg-unidad-upload-hint.is-muted {
  color: var(--text-color-secondary, #6c757d);
  font-size: 0.85rem;
}

.glosa-editor {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 240px;
}
</style>